import ReflectionView from '@/views/ReflectionView';
import { types } from '@/store/rootTypes';
import Reflections from '../components/pages/reflections/Reflections';
import ReflectionDetails from '../components/pages/reflections/ReflectionDetails';
import AnalysisDetails from '../components/pages/AnalysisDetails';
import Portfolio from '../components/pages/Portfolio';
import PortfolioV2 from '../components/pages/PortfolioV2';
import Admin from '../components/pages/admin/Admin';
import OrgAdmin from '../components/pages/orgadmin/OrgAdmin';
import Analytics from '../components/pages/analytics/Analytics';
import Home from '../components/pages/Home';
import store from '../store';
import AuthenticatedApp from '../views/AuthenticatedApp';
import RecommendationBasedNewspaper from '../components/pages/RecommendationBasedNewspaper';
import JournalValidation from '../components/pages/JournalValidation';

const DEFAULT_ROUTE = 'home';
const PORTFOLIO_V2 = true;

const restrictedRoutes = [
  { path: '/index.html', redirect: '' }, // Workaround iOS not able to load / directly
  { path: '', redirect: { name: 'portfolio' } },
  {
    path: '',
    redirect: '/portfolio',
  },
  {
    path: '/home',
    name: DEFAULT_ROUTE,
    component: Home,
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    ...portfolioComponent(),
  },
  {
    path: 'doc/:documentId/:analysisId?',
    name: 'analysis-details',
    component: AnalysisDetails,
    props: true,
  },
  {
    path: '/journalv2',
    name: 'journalv2',
    component: RecommendationBasedNewspaper,
  },
  {
    path: '/journalValidation',
    name: 'journalValidation',
    component: JournalValidation,
  },
  {
    path: '/reflections',
    component: ReflectionView,
    children: [
      {
        path: '',
        name: 'reflections',
        component: Reflections,
      },
      {
        path: ':reflectionId',
        name: 'reflectionDetails',
        component: ReflectionDetails,
      },
    ],
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
  },
  {
    path: '/analytics',
    name: 'analytics',
    component: Analytics,
  },
  {
    path: '/org-admin',
    name: 'admin',
    component: OrgAdmin,
  },
];

function portfolioComponent() {
  if (PORTFOLIO_V2) {
    return {
      component: PortfolioV2,
      props: {
        searchEnabled: true,
        sidebarEnabled: false,
      },
    };
  }

  return {
    component: Portfolio,
    props: {
      enableSearch: true,
    },
  };
}

function getTitleId(name) {
  if (name) {
    return `navigation.${name}.title`;
  }
  return `navigation.${DEFAULT_ROUTE}.title`;
}

export default {
  path: '',
  component: AuthenticatedApp,
  props: (route) => {
    const { name } = route;
    return { title: getTitleId(name) };
  },
  beforeEnter(to, from, next) {
    if (!store.getters[types.authentication.getters.isAuthenticated]) {
      next('/logout');
    } else {
      next();
    }
  },
  children: restrictedRoutes,
};
